<template>
  <div>
    <v-dialog v-model="dialog" max-width="560px" persistent>
      <v-card class="br-card">
        <div class="br-header">
          <v-icon color="white" size="20" class="mr-2">mdi-bug-outline</v-icon>
          <span>Raportează o problemă</span>
          <v-spacer />
          <v-btn icon variant="text" density="comfortable" @click="dialog = false">
            <v-icon color="white" size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="br-body">
          <div class="br-label">Ce s-a întâmplat?</div>
          <v-textarea v-model="descriere" variant="outlined" rows="4" density="comfortable"
                      placeholder="Descrie pe scurt problema (ce făceai, ce ai văzut)..." hide-details />

          <div class="br-context">
            <div><b>Pagina:</b> {{ ruta }}</div>
            <div><b>Versiune:</b> {{ versiune }}</div>
            <div><b>Erori consolă captate:</b> {{ errCount }}</div>
            <div><b>Request-uri API eșuate:</b> {{ netErrCount }}</div>
          </div>

          <div class="br-shot-row">
            <v-switch v-model="atasezScreenshot" color="#ff2c21" density="compact" hide-details
                      label="Atașează captură de ecran" />
          </div>
          <div v-if="atasezScreenshot && screenshot" class="br-shot-preview">
            <img :src="screenshot" alt="captură" />
          </div>
          <div v-else-if="atasezScreenshot && capturing" class="br-shot-msg">Se capturează ecranul...</div>
        </v-card-text>

        <v-card-actions class="justify-end br-actions">
          <v-btn variant="text" @click="dialog = false" :disabled="sending">Anulează</v-btn>
          <v-btn color="#ff2c21" variant="flat" :loading="sending"
                 :disabled="!descriere.trim()" @click="submit">Trimite</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import html2canvas from 'html2canvas';
import notify from 'devextreme/ui/notify';
import AppSettings from '@/settings/appSettings';
import BugReportService from '@/services/BugReportService';
import { getErrorLogText, getErrorCount, getNetworkLogText, getNetworkErrorCount } from '@/utility/errorBuffer';

export default defineComponent({
  name: 'BugReportWidget',
  data() {
    return {
      dialog: false,
      descriere: '',
      atasezScreenshot: true,
      screenshot: '' as string,
      capturing: false,
      sending: false,
      errCount: 0,
      netErrCount: 0,
      versiune: AppSettings.APP_Version,
    };
  },
  computed: {
    ruta(): string { return this.$route?.fullPath || ''; },
  },
  methods: {
    async open() {
      this.descriere = '';
      this.screenshot = '';
      this.errCount = getErrorCount();
      this.netErrCount = getNetworkErrorCount();
      // Capturăm ecranul ÎNAINTE de a deschide dialogul (ca să nu apară dialogul în poză).
      if (this.atasezScreenshot) {
        this.capturing = true;
        try {
          const canvas = await html2canvas(document.body, {
            scale: 0.6, logging: false, useCORS: true, backgroundColor: '#ffffff',
          });
          this.screenshot = canvas.toDataURL('image/jpeg', 0.7);
        } catch (e) {
          console.warn('Nu s-a putut captura ecranul', e);
          this.screenshot = '';
        } finally {
          this.capturing = false;
        }
      }
      this.dialog = true;
    },
    companie(): string {
      try {
        const c = JSON.parse(localStorage.getItem('ERA_Company') || '{}');
        return c?.Name || '';
      } catch { return ''; }
    },
    async submit() {
      if (!this.descriere.trim()) return;
      this.sending = true;
      try {
        await BugReportService.add({
          Descriere: this.descriere.trim(),
          Companie: this.companie(),
          Ruta: this.ruta,
          VersiuneApp: this.versiune,
          Browser: navigator.userAgent,
          ConsoleLog: getErrorLogText(),
          NetworkLog: getNetworkLogText(),
          ScreenshotBase64: this.atasezScreenshot ? this.screenshot : null,
        });
        notify('Mulțumim! Problema a fost raportată.', 'success', 3000);
        this.dialog = false;
      } catch (e: any) {
        notify('Nu am putut trimite raportul. Încearcă din nou.', 'error', 4000);
      } finally {
        this.sending = false;
      }
    },
  },
});
</script>

<style scoped>
.br-card { border-radius: 12px; overflow: hidden; }
.br-header {
  display: flex; align-items: center;
  padding: 12px 18px; color: #fff; font-weight: 700; font-size: 15px;
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
}
.br-body { padding: 18px !important; }
.br-label { font-size: 11px; font-weight: 600; text-transform: uppercase;
  color: #94a3b8; letter-spacing: .5px; margin-bottom: 6px; }
.br-context { margin-top: 12px; font-size: 12px; color: #475569; line-height: 1.6; }
.br-shot-row { margin-top: 6px; }
.br-shot-preview { margin-top: 6px; border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden; }
.br-shot-preview img { width: 100%; display: block; max-height: 220px; object-fit: contain; background: #f8f9fc; }
.br-shot-msg { margin-top: 6px; font-size: 12px; color: #94a3b8; }
.br-actions { padding: 8px 16px 16px; }
</style>
